<script lang="ts">
  import DeliveryDateContainer from "./DeliveryDateContainer.svelte";
  import type { DistributorOrder } from "@shared/types/Order";
  import { convertToDistributorDateLonger } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let order: DistributorOrder;
  export let callbacks;
  export let retailerMode: boolean = false;
  let integratedDelivery: boolean = callbacks.showIntegratedDeliveryDate();

  $: {
    order = order;
    integratedDelivery = callbacks.showIntegratedDeliveryDate();
  }

  function shouldShowBar() {
    if (retailerMode) {
      return order.state == "accepted" && !!order.delivery_date;
    }
    return order.state != "accepted" || order.delivery_date;
  }

</script>

{#if order && !(order.state == "rejected") && shouldShowBar()}
  <div class:padding-bottom--smaller={!integratedDelivery}>
    <div class="grid-container margin-bottom--smallest background-white fizz-styles">
      <div class="fizz-flex-row fizz-surface padding-bottom--small padding-top--small">
        <div class="fizz-flex-item fizz-space-between-responsive">
          <div class="fizz-flex-row fizz-inset-square-8">
            <span class="">
              <Icon type="Truck" height="18" width="24" color="black" />
            </span>
            <div class="fizz-flex-item">
              <div class="fizz-flex-row-8 fizz-stack-2">
                <h4 class="fizz-heading-4">Scheduled Delivery</h4>
              </div>
              <div class="fizz-flex-row-8 fizz-text-medium align-right">
                {#if order.state == "pending" && integratedDelivery}
                  Select the next available delivery date
                {/if}
              </div>
            </div>
          </div>

          <div>
            {#if order.state == "pending" && !retailerMode}
              <DeliveryDateContainer
                {order}
                onSelectDate={callbacks.onSelectDate}
                {integratedDelivery}
              />
            {:else if order.state == "accepted" && order.delivery_date}
              <!-- POST ACCEPT DELIVERY SECONDARY INFO -->
              <div class="fizz-flex-item padding-right--small">
                <p class="align-right">
                  {convertToDistributorDateLonger(order.delivery_date)}
                </p>
                {#if integratedDelivery && !retailerMode}
                  <p class="align-right fizz-text-small">
                    {#if order.delivery_date_off_route}
                      You have selected an Off-Day Delivery date - update in your system.
                    {:else}
                      This delivery date is on your route.
                    {/if}
                  </p>
                {/if}
              </div>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
